export function Tabs(props){

    function setActiveTab(evt, tab) {
        let el = evt.currentTarget;
        let tabs = document.getElementsByClassName('Tab');
        for (var i = 0, len = tabs.length; i < len; i++) {
            tabs[i].classList.remove('active');
        }

        el.classList.add('active');

        props.hideSubMenus();

        switch(tab){
            case 'hom':
                props.showHome();
                break;
            case 'sol':
                props.showSol();
                break;
            case 'ord':
                props.showOrd();
                break;
            case 'men':
                props.showCentralMsg();
                break;
        }

    }


    switch (props.apprPerm){
        case 'R':
            return(
                <>
                    <li className='Tabs__tab Tab Tab_r active' onClick={(e) => setActiveTab(e,'hom')} style={{ 'padding': '0 1rem 0 1rem'}}  id='homeTab'><a>Home</a></li>
                    <li className='Tabs__tab Tab Tab_r' onClick={(e) => setActiveTab(e,'sol')} style={{ 'padding': '0 1rem 0 1rem'}} id='solTab'><a>Solicitação</a></li>
                    <li className='Tabs__tab Tab Tab_r' onClick={(e) => setActiveTab(e,'men')} style={{ 'padding':'0 1rem 0 1rem'}} id='msgTab'><a>Mensagens</a></li>
                    <li className='Tabs__presentation-slider' role="presentation"></li>
                </>
            )
        case 'O':
            return(
                <>
                    <li className='Tabs__tab Tab Tab_o active' onClick={(e) => setActiveTab(e,'hom')} style={{ 'padding': '0 1rem 0 1rem'}} id='homeTab'><a>Home</a></li>
                    <li className='Tabs__tab Tab Tab_o' onClick={(e) => setActiveTab(e,'ord')} style={{ 'padding': '0 1rem 0 1rem'}} id='ordTab'><a>Ordem</a></li>
                    <li className='Tabs__tab Tab Tab_o' onClick={(e) => setActiveTab(e,'men')} style={{ 'padding': '0 1rem 0 1rem'}} id='msgTab'><a>Mensagens</a></li>
                    <li className='Tabs__presentation-slider' role="presentation"></li>
                </>
            )
        case 'RO':
            return(
                <>
                    <li className='Tabs__tab Tab Tab_ro active' onClick={(e) => setActiveTab(e,'hom')} style={{ 'padding': '0 .7rem 0 .7rem'}}  id='homeTab'><a>Home</a></li>
                    <li className='Tabs__tab Tab Tab_ro' onClick={(e) => setActiveTab(e,'sol')}  style={{ 'padding': '0 .7rem 0 .7rem'}} id='solTab'><a>Solicitação</a></li>
                    <li className='Tabs__tab Tab Tab_ro' onClick={(e) => setActiveTab(e,'ord')} style={{ 'padding': '0 .7rem 0 .7rem'}} id='ordTab'><a>Ordem</a></li>
                    <li className='Tabs__tab Tab Tab_ro' onClick={(e) => setActiveTab(e,'men')} style={{ 'padding': '0 .7rem 0 .7rem'}} id='msgTab'><a>Mensagens</a></li>
                    <li className='Tabs__presentation-slider' role="presentation"></li>
                </>
            )
        default:
            return(
                <>
                    <li className='Tabs__tab Tab Tab_def active' style={{ 'padding': '0 2.5rem 0 2.5rem'}} id='homeTab'  onClick={(e) => setActiveTab(e,'hom')} ><a>Home</a></li>
                    <li className='Tabs__tab Tab Tab_def' style={{ 'padding': '0 2.5rem 0 2.5rem'}} id='msgTab'  onClick={(e) => setActiveTab(e,'men')}><a>Mensagens</a></li>
                    <li className='Tabs__presentation-slider' role="presentation"></li>
                </>
            )
           
    }   


    
}